module.exports = __webpack_public_path__ + "img/DrowRanger.411d4531.png";